import http from '~/http/index';
import newhttp from '~/http/new';
// import { sciToDec } from '~/utils/scientific-to-decimal';

export default ({
  state: {
    currencies: [],
    p2p_currencies: [],
    inUseCurrencies: [],
    markets: [],
  },

  getters: {
    getCurrencyById: (state) => (id) => state.currencies.find((e) => e.id === id),
    getP2PCurrencyById: (state) => (id) => state.p2p_currencies.find((e) => e.id === id),
    getCurrencyByTitle: (state) => (title) => state.currencies.find((e) => e.title === title),
    getP2PCurrencyByTitle: (state) => (title) => state.p2p_currencies.find((e) => e.title === title),
    getCurrencyBySymbol: (state) => (symbol) => state.currencies.find((e) => e.symbol === symbol),
    getCurrencyByName: (state) => (name) => state.currencies.find((e) => e.name === name),

    toCurrencyFormat: (state) => (value, currencyLabel) => {
      const currency = state.currencies.find((e) => {
        return (e.id === currencyLabel) || (e.title === currencyLabel);
      });
      const decimalsCount = currency ? currency.decimals : 8;
      return new Intl.NumberFormat(
        'en-US',
        { maximumFractionDigits: decimalsCount },
      ).format(value);
    },

    getUrlTx: (_state, _getters, _rootState, rootGetters) => (txId, currencyLabel) => {
      const currency = rootGetters['paymentsAndCurrenciesPayments/cryptoCurrencies'].find((e) => {
        return (e.id === currencyLabel) || (e.title === currencyLabel);
      });
      if (!currency) return null;
      const { urlTx } = currency;
      if (!urlTx) return null;
      return urlTx.replace('{txid}', txId);
    },

    getTokenUrlTx: (_state, _getters, _rootState, rootGetters) => (txId, currencyLabel) => {
      const currency = rootGetters['paymentsAndCurrenciesPayments/cryptoTokens'].find((e) => {
        return (e.id === currencyLabel) || (e.title === currencyLabel);
      });
      const { urlTx } = currency;
      if (!currency || !urlTx) return null;
      return urlTx.replace('{txid}', txId);
    },

    getUrlAddress: (_state, _getters, _rootState, rootGetters) => (address, currencyLabel) => {
      const currency = rootGetters['paymentsAndCurrenciesPayments/cryptoCurrencies'].find((e) => {
        return (e.id === currencyLabel) || (e.title === currencyLabel);
      });
      if (!currency) return null;
      const { urlAddress } = currency;
      if (!urlAddress) return null;
      return urlAddress.replace('{address}', address);
    },

    getTokenUrlAddress: (_state, _getters, _rootState, rootGetters) => (address, currencyLabel) => {
      const currency = rootGetters['paymentsAndCurrenciesPayments/cryptoTokens'].find((e) => {
        return (e.id === currencyLabel) || (e.title === currencyLabel);
      });
      if (!currency) return null;
      const { urlAddress } = currency;
      if (!urlAddress) return null;
      return urlAddress.replace('{address}', address);
    },
  },

  mutations: {
    SET_CURRENCIES(state, data) {
      state.currencies = data.map((item) => {
        return {
          ...item, name: `${item.name} (${item.title})`,
        };
      });
    },

    SET_IN_USE_CURRENCIES(state, data) {
      state.inUseCurrencies = data.items;
    },

    SET_P2P_CURRENCIES(state, data) {
      state.p2p_currencies = data;
    },

    SET_MARKETS(state, data) {
      state.markets = data;
    },
  },

  actions: {
    async getCurrencies({ commit }) {
      const { data } = await http.get('Market/GetCurrencies');
      await commit('SET_CURRENCIES', data);
    },

    async getCurrenciesInUse({ commit }) {
      const { data } = await http.post('v2/Market/GetCurrencies', { isInUse: true });
      await commit('SET_IN_USE_CURRENCIES', data);
    },

    async getP2PCurrencies({ commit }) {
      const { data } = await newhttp.get('v1/currencies');
      await commit('SET_P2P_CURRENCIES', data.items);
    },

    async getMarkets({ commit }) {
      const { data } = await http.get('Market/GetMarkets');
      await commit('SET_MARKETS', data);
    },
  },

  namespaced: true,
});
